import { v4 as uuid } from 'uuid';

import { PlankToMwdDragItem, PlankToMwdDragKind, PlankToMwdDragPayload } from '@/utils/plankToMwdDrag';

import usePlankTableStore from '../hooks/usePlankTableStore';

/** Builds the stable key identifying a Plank row in the selection state, e.g. `defect:12345`. */
export function buildPlankSelectionKey(kind: PlankToMwdDragKind, sourceId: string): string {
  return `${kind}:${sourceId}`;
}

/** Builds the drag payload to broadcast for a Plank-to-MWD drag. When the dragged row is part
 * of the current multi-selection (2 or more rows selected), the payload carries every selected
 * item as a batch (`items`); otherwise it's a regular single-item payload built from the
 * dragged row's own data, unaffected by any unrelated selection that may exist elsewhere.
 */
export function buildPlankToMwdDragPayload(selfItem: PlankToMwdDragItem): PlankToMwdDragPayload {
  const selection = usePlankTableStore.getState().getPlankSelection();
  const key = buildPlankSelectionKey(selfItem.kind, selfItem.sourceId);
  const isBatchDrag = selection.length > 1 && selection.some((selected) => selected.key === key);

  return {
    ...selfItem,
    sessionId: uuid(),
    timestamp: Date.now(),
    items: isBatchDrag ? selection.map(({ key: _key, ...item }) => item) : undefined,
  };
}
